// initial state
const state = () => ({
  form     : null,
  sort     : null,
  isRefresh: false,
  isBack   : false,
});

// getters
const getters = {
  formData : (state) => {
    return state.form;
  },
  sortData : (state) => {
    return state.sort;
  },
  isRefresh: (state) => {
    return state.isRefresh;
  },
  isBack   : (state) => {
    return state.isBack;
  },
};

// actions
const actions = {
  saveFormData({commit}, formData) {
    commit('setRefresh', false);
    commit('setBack', false);
    commit('setFormData', formData);
  },
  saveSortData({commit}, sortData) {
    commit('setRefresh', false);
    commit('setBack', false);
    commit('setSortData', sortData);
  },
  saveRefresh({commit}, isRefresh) {
    if (isRefresh === true && this.state.form === null) {
      isRefresh = false;
    }
    commit('setRefresh', isRefresh);
  },
  saveBack({commit}, isBack) {
    if (isBack === true && this.state.form === null) {
      isBack = false;
    }
    commit('setBack', isBack);
  },
};

// mutations
const mutations = {
  setFormData(state, payload) {
    state.form = payload;
  },
  setSortData(state, payload) {
    state.sort = payload;
  },
  setRefresh(state, isRefresh) {
    state.isRefresh = isRefresh;
  },
  setBack(state, isBack) {
    state.isBack = isBack;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
